import { runtimeEnv } from '@/utils/runtimeEnv'

/**
 * Identifier for the running SPA build.
 *
 * Prefers the pipeline build number injected into /env-config.js at deploy time
 * (VITE_SPA_BUILD); falls back to __BUILD_ID__, the per-build hash compiled in
 * by vite.config.ts — the same hash used to cache-bust env-config.js.
 *
 * Used to stamp telemetry (so a minified stack can be matched to the source map
 * of the build that produced it) and to bust the persisted React Query cache.
 */
export const BUILD_ID: string = runtimeEnv.VITE_SPA_BUILD || __BUILD_ID__
